export default "<tc-generic-list #estimationsList id=\"estimations-list\"></tc-generic-list>";